import Footer from 'modules/common/components/footer';
import Navbar from 'modules/common/components/navbar';

export default function FAQCreationPage() {
  return (
    <>
      <div className="bg-[url('/src/modules/common/assests/images/home-background.png')] bg-no-repeat bg-cover h-auto">
        <Navbar />
      </div>
      <div className='relative py-16 bg-black overflow-hidden'>
        <div className='relative px-4 sm:px-6 lg:px-8'>
          <div className='text-lg max-w-screen-lg mx-auto'>
            <h1>
              <span className='block text-base text-center text-[#00ce1b] font-semibold tracking-wide uppercase'>
                NFT Creation
              </span>
              <span className='mt-2 block text-3xl text-center leading-8 font-extrabold tracking-tight text-white sm:text-4xl'>
                How to create nfts using greenartcoin?
              </span>
            </h1>
            <p className='mt-8 text-xl text-gray-300 leading-8'>
              Anyone can create an NFT. Your NFT can be as simple as the media
              itself, but it can also represent something more. Think of it this
              way: your NFT can simply be a piece of art, or it can be a piece
              of music represented by a GIF or a photograph. In the latter
              example, the NFT is the combination of the representation and the
              digital item it represents.
            </p>
          </div>
          <div className='mt-6 prose prose-green max-w-screen-lg text-gray-300 mx-auto'>
            <h2 className='text-white'>What do I need to create an NFT?</h2>
            <p className='mt-8 text-xl text-gray-300 leading-8'>
              In addition to the NFT itself, you’ll need a crypto wallet to
              create and mint your NFT.
            </p>
            <p className='mt-8 text-xl text-gray-300 leading-8'>
              “Minting” an NFT is the process of writing a digital item to the
              blockchain. This establishes its immutable record of authenticity
              and ownership.
            </p>
            <p className='mt-8 text-xl text-gray-300 leading-8'>
              Crypto Wallet are a foundational tool of web3. Your wallet acts as
              a private key that allows you to interact with decentralized apps,
              buy NFTs, and navigate the web3 universe. Each blockchain has
              specific wallets you can use to transact on them. For example,
              MetaMask is a wallet used to interact with the Binance Smart
              Chain. GreenArt Coin is compatible with a wide variety of wallets.
            </p>
            <p className='mt-8 text-xl text-gray-300 leading-8'>
              Next, choose a blockchain on which to mint your NFT. GreenArt
              Coinais currently compatible with the BNB CHAIN for first and in
              the future multichain (Ethereum, Polygon, Klaytn, Arbitrum,
              Optimism, Avalanche and Solana blockchains, and each of these
              blockchain has different gas fee associated with transactions on
              their networks.
            </p>
            <p className='mt-8 text-xl text-gray-300 leading-8'>
              Then, you can create your collection. This is the fun part! Decide
              what your collection of NFTs is all about. Is it artwork, a
              collection of profile pictures, sports memorabilia, membership to
              a group, or something else entirely? Once you decide, create your
              collection by naming it something unique that represents your work
              and describing it. You’ll also be prompted to choose a category
              and provide any relevant links to social media.
            </p>
            <p className='mt-8 text-xl text-gray-300 leading-8'>
              Once your crypto wallet is set up, you’ve chosen BNB blockchain,
              and your collection has been created, you’re ready to mint your
              NFTs!
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
